import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import FileUpload from "./components/FileUpload";
import ResultsPage from "./components/ResultsPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// ❌ Ta vrstica ni potrebna, če že v `ResultsPage` prikazuješ suggestions
// import SuggestionsPage from "./components/SuggestionsPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<FileUpload />} />
        {/* ✅ Sprejme več ID-jev ločenih z vejico */}
        <Route path="/results/:documentIds" element={<ResultsPage />} />


        {/* ❌ Če `SuggestionsPage` ni ločena stran, potem ta vrstica ni potrebna */}
        {/* <Route path="/suggestions/:documentId" element={<SuggestionsPage />} /> */}
      </Routes>
              <ToastContainer
        position="top-center"
        autoClose={3000}
        toastClassName="flex justify-center items-center"
        bodyClassName="text-center px-6 md:px-8"

      />
    </Router>
  );
}

export default App;
